import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { bulkUpdateAutoTranscribe } from "../api/users";

export const useBulkUpdateAutoTranscribe = (onSuccess) => {
  const queryClient = useQueryClient();

  const bulkUpdateAutoTranscribeMutation = useMutation({
    mutationFn: async ({ userSqids, autoTranscribe }) => {
      return bulkUpdateAutoTranscribe(userSqids, autoTranscribe);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["team-members-search"],
      });
      toast.success(
        `${variables.userSqids.length} user auto-transcribe ${
          variables.userSqids.length === 1 ? "" : "s"
        } ${variables.autoTranscribe ? "enabled" : "disabled"}`,
      );
      onSuccess?.();
    },
    onError: () => {
      toast.error(
        "There was a problem updating auto-transcribe. Please try again.",
      );
    },
  });

  return { bulkUpdateAutoTranscribeMutation };
};